<script setup lang="ts">

import { currency } from '@library/Utilities';
import { WorkOrderType } from '../Types/WorkOrderType';

import TyreReplacement from '@/assets/images/Products/stacked-tyres-001.png';
import TyreRepair from '@/assets/images/Products/tyre-repair-001.png';
import Brakes from '@/assets/images/Products/disc-brakes-001.png';
import Battery from '@/assets/images/Products/battery-001.png';
import WiperBlades from '@/assets/images/Products/wipers-001.png';
import KeyFob from '@/assets/images/Products/key-fob-001.png';

type Props = {
    option: {
        title: string,
        type: WorkOrderType,
        amount: number,
        count: number,

    }
    flip?: boolean
}

const { flip = false } = defineProps<Props>();

const images = [
    Battery, // 0
    Brakes, // 1
    KeyFob, // 2
    TyreRepair, // 3
    TyreReplacement, // 4
    WiperBlades, // 5
];

</script>

<template>

    <div class="mb-12 last:mb-0 flex gap-6 items-center"
        :class="{ 'flex-row-reverse': flip }">
        
        <img :src="images[ option.type ]" class="h-16 w-16 scale-125" />

        <div class="text-sm tracking-wider w-full"
            :class="flip ? 'text-right' : 'text-left'">
            <div class="text-base uppercase font-semibold">
                {{ option.title }}
            </div>
            <div>
                <span class="text-white font-semibold">
                    {{ option.count }}
                </span> 
                <span class="text-white/60">
                    repair{{ option.count != 1 ? 's' : '' }}/replacement{{ option.count != 1 ? 's' : '' }}
                </span>
            </div>
            <div class="text-amber-400 font-semibold">
                Benefit {{ currency( option.amount, '$', false ) }}
            </div>
        </div>

    </div>

</template>